import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Modal,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { DataTable, MainLoader } from "../../../../components";
import { toast } from "react-toastify";
import MediaQuery from "react-responsive";
import { layout } from "../../../../common/constants";
import { getProducts } from "../../../../store/product/actions";
import { getServices } from "../../../../store/service/actions";
import {
  getOffer,
  updateOffer,
  deleteOfferImage,
  uploadOfferImage,
  resetOffer,
  resetUpdateOffer,
} from "../../../../store/offer/actions";
import * as columns from "./_columns";
import { FormItem, FormOffer, FormSelectItem } from "./Forms";

class OfferEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemType: "",
      modalOpen: false,
      itemModalOpen: false,

      selectedProducts: [],
      selectedServices: [],
      selectedItem: null,

      image: null,
      withCurrentImage: false,
      currentImageRemoved: false,
      counter: 0,
    };
    this.onSubmitOffer = this.onSubmitOffer.bind(this);
    this.onSubmitOfferItem = this.onSubmitOfferItem.bind(this);
    this.onSelectOfferItem = this.onSelectOfferItem.bind(this);

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleItemModal = this.toggleItemModal.bind(this);
    this.changeImage = this.changeImage.bind(this);
    this.changeImageState = this.changeImageState.bind(this);
    this.optionsFormatterColumnProducts =
      this.optionsFormatterColumnProducts.bind(this);
    this.optionsFormatterColumnServices =
      this.optionsFormatterColumnServices.bind(this);
  }

  async componentDidMount() {
    await this.props.getProducts({ reset: true });
    await this.props.getServices({ reset: true });
    await this.props.getOffer(this.props.match.params.id);
    let previousProducts = [];
    let previousServices = [];

    if (this.props.offer.Offer_products) {
      this.props.offer.Offer_products.forEach((element) => {
        element.oid = this.state.counter;
        this.state.counter = this.state.counter + 1;
        previousProducts.push(element);
      });

      this.setState({
        selectedProducts: previousProducts,
      });
    }

    if (this.props.offer.Offer_services) {
      this.props.offer.Offer_services.forEach((element) => {
        element.oid = this.state.counter;
        this.state.counter = this.state.counter + 1;
        previousServices.push(element);
      });

      this.setState({
        selectedServices: previousServices,
      });
    }
  }

  componentDidUpdate(prevProps) {
    this.checkOfferFetch(prevProps);
    this.checkOfferUpdate(prevProps);
    this.checkUploadOfferImage(prevProps);
    this.checkDeleteOfferImage(prevProps);
  }
  componentWillUnmount() {
    this.props.resetOffer();
    this.props.resetUpdateOffer();
  }
  checkOfferFetch(prevProps) {
    if (prevProps.offer == null && this.props.offer != null) {
      const { imageUrl } = this.props.offer;
      if (imageUrl) this.setState({ withCurrentImage: true });
    }
  }

  checkOfferUpdate(prevProps) {
    if (prevProps.updatedOffer == null && this.props.updatedOffer != null) {
      const { withCurrentImage, image, currentImageRemoved } = this.state;
      const { id } = this.props.match.params;

      if (!withCurrentImage && image != null) {
        this.props.uploadOfferImage(id, image);
        return;
      } else if (currentImageRemoved && image == null) {
        this.props.deleteOfferImage(id);
        return;
      }
      this.onSuccess();
    }
  }

  checkUploadOfferImage(prevProps) {
    if (
      prevProps.uploadedImageOffer == null &&
      this.props.uploadedImageOffer != null
    ) {
      this.onSuccess();
    }
    if (
      prevProps.uploadedImageError == null &&
      this.props.uploadedImageError != null
    ) {
      this.onSuccess("Sin embargo, no se ha podido guardar la foto.");
    }
  }

  checkDeleteOfferImage(prevProps) {
    if (!prevProps.deleteImageSuccess && this.props.deleteImageSuccess) {
      this.onSuccess();
    }
  }
  onSuccess(message = "") {
    let toastMessage = `Oferta actualizada satisfactoriamente. ${message}`;
    toast.success(toastMessage);
    this.props.history.push("/administration/offers");
  }

  onSubmitOffer(values) {
    values.Offer_products = this.state.selectedProducts;
    values.Offer_services = this.state.selectedServices;
    if (values.Offer_products.length + values.Offer_services.length > 0) {
      this.props.updateOffer(this.props.match.params.id, values);
    } else {
      let toastMessage = "No se han agregado productos o servicios";
      toast.error(toastMessage);
    }
  }
  onSubmitOfferItem(values, activeItem) {
    var { selectedProducts, selectedServices, itemType, counter } = this.state;
    if (itemType == "Productos") {
      var products = selectedProducts;
      values.Product = {};
      values.Product.name = activeItem.name;
      values.oid = counter;
      counter++;
      products.push(values);
      this.setState({
        selectedProducts: products,
        modalOpen: false,
        itemModalOpen: false,
        counter: counter,
      });
    } else {
      let services = selectedServices;
      values.Service = {};
      values.Service.name = activeItem.name;
      values.oid = counter;
      counter++;
      services.push(values);
      this.setState({
        selectedServices: services,
        modalOpen: false,
        itemModalOpen: false,
        counter: counter,
      });
    }
  }

  onSelectOfferItem(item) {
    this.setState({ selectedItem: item });
  }

  async toggleModal(type) {
    await this.setState({
      itemType: type,
      modalOpen: !this.state.modalOpen,
    });
    if (!this.state.modalOpen)
      this.setState({
        selectedItem: {
          id: null,
          name: null,
          price: null,
        },
      });
  }

  async toggleItemModal() {
    await this.setState({
      itemModalOpen: !this.state.itemModalOpen,
    });
    if (this.state.itemModalOpen)
      this.setState({
        selectedItem: {
          id: null,
          name: null,
          price: null,
        },
      });
  }

  changeImage(file) {
    this.setState({
      image: file,
    });
  }

  changeImageState(withCurrentImage, currentImageRemoved) {
    this.setState({
      withCurrentImage: withCurrentImage,
      currentImageRemoved: currentImageRemoved,
    });
  }

  async performDeleteItem(oid, type) {
    var list =
      type == "Productos"
        ? this.state.selectedProducts
        : this.state.selectedServices;
    list = list.filter(function (obj) {
      return obj.oid !== oid;
    });
    if (type == "Productos") {
      await this.setState({
        selectedProducts: list,
      });
    } else {
      await this.setState({ selectedServices: list });
    }
  }

  optionsFormatterColumnProducts(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => this.performDeleteItem(row.oid, "Productos")}
          >
            <i className="fa fa-trash mr-1"></i> Eliminar
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }
  optionsFormatterColumnServices(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => this.performDeleteItem(row.oid, "Servicios")}
          >
            <i className="fa fa-trash mr-1"></i> Eliminar
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }

  renderDataTable(columns, data) {
    return (
      <DataTable
        data={data}
        keyField="oid"
        columns={columns}
        loading={this.props.loading}
      />
    );
  }

  render() {
    const columnOptionProducts = {
      dataField: "",
      text: "",
      isDummyField: true,
      formatter: this.optionsFormatterColumnProducts,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };
    const columnOptionService = {
      dataField: "",
      text: "",
      isDummyField: true,
      formatter: this.optionsFormatterColumnServices,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };
    const {
      modalOpen,
      itemModalOpen,
      selectedProducts,
      selectedServices,
      itemType,
    } = this.state;
    const {
      error,
      uploadedImageLoading,
      updatedLoading,
      deleteImageLoading,
      loading,
      servicesLoading,
      productsLoading,
    } = this.props;

    const isLoading = loading || servicesLoading || productsLoading;
    const isLoadingSubmit =
      uploadedImageLoading || updatedLoading || deleteImageLoading;

    if (isLoading) {
      return <MainLoader />;
    }

    return (
      <div className="animated">
        <Card>
          <CardHeader>Editar Oferta</CardHeader>
          <CardBody>
            {error && <Alert color="danger">{error}</Alert>}
            <FormOffer
              onSubmitOffer={this.onSubmitOffer}
              toggleModal={this.toggleModal}
              modalOpen={modalOpen}
              itemType={itemType}
              isLoading={isLoadingSubmit}
              changeImage={this.changeImage}
              initialValues={this.props.offer}
              withCurrentImage={this.state.withCurrentImage}
              changeImageState={this.changeImageState}
              selectedServices={this.state.selectedServices}
              selectedProducts={this.state.selectedProducts}
            ></FormOffer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader>Items de Oferta</CardHeader>
          <CardBody>
            {selectedProducts.length > 0 && (
              <Row>
                <Col>
                  <Row>
                    <Col>
                      <Label>
                        <b>Productos</b>
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsProductXS(columnOptionProducts),
                          selectedProducts
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsProductSM(columnOptionProducts),
                          selectedProducts
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsProduct(columnOptionProducts),
                          selectedProducts
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {this.state.selectedServices.length > 0 && (
              <Row>
                <Col>
                  <Row>
                    <Col>
                      <Label>
                        <b>Servicios</b>
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsServiceXS(columnOptionService),
                          selectedServices
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsServiceSM(columnOptionService),
                          selectedServices
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsService(columnOptionService),
                          selectedServices
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
        <Modal isOpen={modalOpen}>
          <FormItem
            products={this.props.products}
            services={this.props.services}
            selectedItem={this.state.selectedItem}
            itemType={this.state.itemType}
            onSubmitOfferItem={this.onSubmitOfferItem}
            toggleModal={this.toggleModal}
            toggleItemModal={this.toggleItemModal}
          />
        </Modal>
        <Modal isOpen={itemModalOpen}>
          <FormSelectItem
            itemType={this.state.itemType}
            onSubmitItem={this.onSelectOfferItem}
            toggleModal={this.toggleItemModal}
          ></FormSelectItem>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { offer, loading, error } = state.offer.offerList;

  const { productList } = state.product;
  const { serviceList } = state.service;

  const { updateOffer, uploadImageOffer, deleteImageOffer } = state.offer;
  return {
    offer,
    loading,
    error,

    updatedOffer: updateOffer.offer,
    updatedError: updateOffer.error,
    updatedLoading: updateOffer.loading,

    products: productList.products,
    productsLoading: productList.loading,

    services: serviceList.services,
    servicesLoading: serviceList.loading,

    uploadedImageOffer: uploadImageOffer.imageUrl,
    uploadedImageLoading: uploadImageOffer.loading,
    uploadedImageError: uploadImageOffer.error,

    deleteImageSuccess: deleteImageOffer.success,
    deleteImageLoading: deleteImageOffer.loading,
    deleteImageError: deleteImageOffer.error,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProducts,
      getServices,
      getOffer,
      updateOffer,
      uploadOfferImage,
      deleteOfferImage,
      resetOffer,
      resetUpdateOffer,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferEdit);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferEdit/OfferEdit.js